export const stats = {
  companyoverviewtitle: 'CashClever Overview',
  companyoverviewsubtitle:
    'With cutting-edge algorithms, we enable consumers to make data-driven decisions and unlock insights that were previously unavailable',
  companyoverviewstat1: '120+',
  companyoverviewstat2: '30k$',
  companyoverviewstat3: '35+',
  companyoverviewstat1Sub: 'Happy Clients',
  companyoverviewstat2Sub: 'Total Fund',
  companyoverviewstat3Sub: 'Employees',
};
